import { styled } from '@linaria/react';

export const TextareaElement = styled.textarea<{ isError?: boolean }>`
	padding: 12px;
	width: 100%;
	font-family: var(--font);
	color: var(--color-white);
	font-size: 16px;
	line-height: 22px;
	background: var(--color-white-01);
	border: 1px solid
		${({ isError }) => (isError ? 'var(--color-error)' : 'transparent')};
	border-radius: 12px;
	transition: border-color 0.3s, box-shadow 0.15s;
	resize: none;

	&::placeholder {
		color: var(--color-white-07);
	}

	&:focus {
		border-color: var(--bot-color-main);
		box-shadow: 0px 2px 18px 2px rgb(from var(--bot-color-main) r g b / 50%);
	}

	&[disabled] {
		opacity: 0.7;
		pointer-events: none;
	}
`;
